export const codeToCountry = {
	AT: 'Austria',
	BE: 'Belgium',
	CY: 'Cyprus',
	DK: 'Denmark',
	EE: 'Estonia',
	FI: 'Finland',
	FR: 'France',
	DE: 'Germany',
	DEB: 'Germany (Berlin)',
	DEH: 'Germany (Hesse)',
	GR: 'Greece',
	HU: 'Hungary',
	IE: 'Ireland',
	IL: 'Israel',
	IT: 'Italy',
	LU: 'Luxembourg',
	MT: 'Malta',
	NL: 'Netherlands',
	PT: 'Portugal',
	ES: 'Spain',
	SE: 'Sweden',
	SI: 'Slovenia',
	CH: 'Switzerland',
	UA: 'Ukraine',
	UKE: 'UK (England)',
	UKNI: 'UK (Northern Ireland)',
	UKS: 'UK (Scotland)',
	UKW: 'UK (Wales)',
};

export const countryToCode = {};
Object.keys(codeToCountry).forEach((code) => (countryToCode[codeToCountry[code]] = code));

export const participatingCountries = Object.values(codeToCountry);

export const ageGroups = {
	Total: 'All ages',
	'0to4': '0-4 years',
	'0to14': '0-14 years',
	'5to14': '5-14 years',
	'15to44': '15-44 years',
	'15to64': '15-64 years',
	'45to64': '45-64 years',
	'65to74': '65-74 years',
	'75to84': '75-84 years',
	'65P': '65+ years',
	'85P': '85+ years',
};

export const getAgeOptions = (ages) => {
	const options = [];
	for (let i = 0; i < ages.length; i++) {
		options.push({ label: ageGroups[ages[i]] || ages[i], value: ages[i] });
	}
	const keys = Object.keys(ageGroups);
	options.sort((a, b) => keys.indexOf(a.value) - keys.indexOf(b.value));
	return options;
};

export function uid(prefix = 'comp') {
	return prefix + '-' + Math.random().toString(36).substring(2, 16);
}

export const downloadFile = (filename, text) => {
	const el = document.createElement('a');
	el.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
	el.setAttribute('download', filename);
	el.style.display = 'none';
	document.body.appendChild(el);
	el.click();
	document.body.removeChild(el);
};
